import { SourcingSharedJobInformationBackProps } from 'modules/sourcing-shared/shared-stores/types';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { Channels } from 'generated-graphql/types';
import { scrollToTop } from 'common/utils';

type HandleSourcingSharedJobInformationBackControllerProps =
  SourcingSharedJobInformationBackProps & {
    set: SharedSourcingStoreApi['setState'];
  };

export const handleSourcingSharedJobInformationBackController = ({
  isChannelSelectionFeatureFlagEnabled,
  organizationChannelsEnabled,
  set
}: HandleSourcingSharedJobInformationBackControllerProps) => {
  scrollToTop();

  const shouldShowChannelSelection =
    isChannelSelectionFeatureFlagEnabled &&
    organizationChannelsEnabled.length > 1 &&
    organizationChannelsEnabled.some(
      (c) => c !== Channels.Email && c !== Channels.Whatsapp
    );

  if (shouldShowChannelSelection) {
    set({
      step: 'CHOOSE_CHANNEL'
    });
  } else {
    set({
      step: 'SELECTED_CANDIDATES'
    });
  }
};
